import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, Button } from 'reactstrap'

const propTypes = {
  selectedInventories : PropTypes.arrayOf(PropTypes.object),
  onRemoveRow         : PropTypes.func,
  formikBag           : PropTypes.shape({
    setFieldValue: PropTypes.func
  })
}

/**
 * Table to display selected borrow Inventory Product
 * @param {array} selectedInventories - Selected Inventory Product
 * @param {func} onRemoveRow - Handler to remove a row
 */
const SelectedBorrowInventoryProductTable = ({
  selectedInventories,
  onRemoveRow,
  formikBag
}) => {

  const { setFieldValue } = formikBag

  useEffect(() => {
    setFieldValue('selected_inventories', selectedInventories)
  }, [ selectedInventories, setFieldValue ])

  return (
    <Table bordered>
      <thead>
        <tr>
          <th>No.</th>
          <th>Inventory SKU</th>
          <th>Name</th>
          <th>Borrow Quantity</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {
          selectedInventories.map((selectedInventory, index) => (
            <tr key={ selectedInventory.id }>
              <td>{ index + 1 }</td>
              <td>{ selectedInventory.inventory_sku }</td>
              <td>{ selectedInventory.product_name }</td>
              <td>{ selectedInventory.quantity }</td>
              <td>
                <Button
                  color='danger'
                  onClick={ () => onRemoveRow(index) }
                >
                Remove
                </Button>
              </td>
            </tr>
          ))
        }
      </tbody>
    </Table>
  )
}

SelectedBorrowInventoryProductTable.propTypes = propTypes

export default SelectedBorrowInventoryProductTable
